import { usePostHog } from 'posthog-js/react';
import type { Survey } from 'posthog-js';

import { SurveyWizard } from '../../generic/Survey/SurveyWizard';

import { ThanksStep } from './ThanksStep';
import { WelcomeStep } from './WelcomeStep';

import styles from './OnboardingSurveyFullscreen.module.less';

type Props = {
  survey: Survey;
  onClose: () => void;
};

/**
 * Fullscreen takeover for the post-signup onboarding survey. Composes
 * `SurveyWizard` with the FOSSA-branded `WelcomeStep` (preStep) and `ThanksStep`
 * (postStep). On submit, sets `seen_onboarding: true` as a person property
 * in PostHog so the survey's targeting suppresses it on future page loads.
 * `onClose` is fired by the Thanks step's Done button to dismiss the takeover.
 */
export const OnboardingSurveyFullscreen = ({ survey, onClose }: Props) => {
  const posthog = usePostHog();
  const handleSubmit = () => {
    posthog?.setPersonProperties({ seen_onboarding: true });
  };
  return (
    <div className={styles.container} data-testid="onboarding-survey-fullscreen">
      <div className={styles.frame}>
        <SurveyWizard
          survey={survey}
          preSteps={[<WelcomeStep key="welcome" />]}
          postSteps={[<ThanksStep key="thanks" onClose={onClose} />]}
          shouldShowProgressBar
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};
